import grayLogger from './graylog';
import consoleLogger from './console/console';
import iotLogger from './iot';
import sentryLogger from './sentry';
export default [grayLogger, consoleLogger, iotLogger, sentryLogger];